export function Banner({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex justify-center bg-red-600 px-4 py-2 text-lg font-bold leading-6 text-white">
      <div>{children}</div>
    </div>
  );
}
